module.exports = __webpack_public_path__ + "static/14-26050a2b10c70a62f903bbbd92986828.jpg";